import { ThemeSkin, ThemeOptions } from '../../publicSession';
export function getBackgroundVariant(theme, themeSkin, supportsGreen) {
    if (theme === void 0) { theme = ThemeOptions.DARK; }
    if (supportsGreen === void 0) { supportsGreen = false; }
    if (themeSkin === ThemeSkin.GREEN &&
        theme === ThemeOptions.LIGHT &&
        supportsGreen) {
        return 'green';
    }
    return theme;
}
//# sourceMappingURL=helpers.js.map